import React from "react"

export default function IosIcon() {
  return (
    <svg
      width="52"
      height="60"
      viewBox="0 0 52 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-fill"
        d="M45.4169 39.2656C43.7581 36.886 42.9292 34.205 42.9292 31.225C42.9292 28.5088 43.7115 26.0202 45.2727 23.7609C46.1141 22.535 47.4846 21.1171 49.3836 19.5063C48.1339 17.9683 46.8839 16.7663 45.6331 15.9007C43.3736 14.3385 40.8133 13.5574 37.953 13.5574C36.2467 13.5574 34.1669 13.9658 31.7156 14.7837C29.3597 15.6009 27.6408 16.01 26.5596 16.01C25.7418 16.01 24.0835 15.6497 21.5835 14.9282C19.0596 14.2069 16.9321 13.8466 15.2013 13.8466C11.0668 13.8466 7.65335 15.5775 4.96117 19.0387C2.24488 22.5484 0.886475 27.0434 0.886475 32.5242C0.886475 38.3415 2.65368 44.3866 6.18709 50.6607C9.76849 56.8865 13.3864 59.9999 17.0402 59.9999C18.2661 59.9999 19.8527 59.5911 21.7995 58.7738C23.7469 57.9812 25.4535 57.584 26.92 57.584C28.482 57.584 30.2972 57.9686 32.3644 58.7375C34.5516 59.506 36.2347 59.8906 37.4124 59.8906C40.4891 59.8906 43.5785 57.5348 46.679 52.8235C48.6978 49.8188 50.1763 46.8142 51.1137 43.8092C48.9743 43.1597 47.0757 41.6453 45.4169 39.2656Z"
        fill="#4996FF"
      />
      <path
        className="white-fill"
        d="M33.1568 11.394C34.6716 9.8796 35.7892 8.22075 36.5106 6.41818C37.2074 4.61536 37.5552 2.9805 37.5552 1.51399C37.5552 1.41814 37.55 1.29778 37.537 1.15343C37.5261 1.0092 37.5197 0.889351 37.5197 0.793116C37.4955 0.720877 37.4656 0.588649 37.4298 0.396558C37.3939 0.204467 37.364 0.0722392 37.3394 0C33.1087 0.986091 30.1041 2.76479 28.3251 5.33699C26.5228 7.93318 25.5848 11.0218 25.5126 14.6034C27.1232 14.4591 28.3726 14.2551 29.2625 13.9905C30.5615 13.5577 31.858 12.692 33.1568 11.394Z"
        fill="#4996FF"
      />
    </svg>
  )
}
